(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("itowns_lasworker", [], factory);
	else if(typeof exports === 'object')
		exports["itowns_lasworker"] = factory();
	else
		root["itowns_lasworker"] = factory();
})(self, () => {
return 